/* ══════════════════════════════════════════════════════════
   PNL CART FRAME OVERLAY — v2 (stable)
   • สูตรเดียวกับหน้าสินค้า: กว้าง/สูง %, เลื่อน x/y %, ความหนาสเกลตาม REF_W 600
   • วัดจาก "เนื้อภาพจริง" (รองรับ object-fit / transform) → กรอบตรงรูปเป๊ะ
   • แก้ Dawn div:empty{display:none} ที่ซ่อนภาพในขอบขาว
   • อ่านค่า/เขียนค่าแยกรอบใน rAF เดียว · ResizeObserver ตัวเดียว · ล้าง node ที่หลุดเอง
   • ไม่สร้างกล่องซ้ำ · rebuild เฉพาะตอน data-* เปลี่ยน · ซ่อนจนวางตำแหน่งเสร็จ (ไม่กระพริบ)
══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var VERSION = 2;
  if (window.PnlCartFrame && window.PnlCartFrame.v === VERSION) { window.PnlCartFrame.scan(); return; }

  var REF_W = 600;
  var BASE_T = 8.5;
  var MAT_RATIO = 0.04;
  var DEF = {
    landscape: { w: 71.75, h: 53.2 },
    portrait:  { w: 45.75, h: 57.7 }
  };
  var WOOD = {
    lightwood: 'https://cdn.shopify.com/s/files/1/0711/4502/9888/files/lightwood_img_copy_copy.jpg?v=1782376062',
    darkwood:  'https://cdn.shopify.com/s/files/1/0711/4502/9888/files/darkwood_img.jpg?v=1781777158'
  };
  var SEL = '[data-pnl-overlay="1"]';
  var DATA_KEYS = ['pnlMode', 'pnlFrame', 'pnlMaterial', 'pnlBorder', 'pnlWb', 'pnlW', 'pnlH', 'pnlX', 'pnlY', 'pnlT'];

  /* ────────── CSS ────────── */
  function injectCSS() {
    var old = document.getElementById('pnl-cof-style');
    if (old) old.remove();
    var css = [
      '.cart-item__image-container[data-pnl-overlay]{position:relative}',
      '.pnl-cof{position:absolute;left:0;top:0;box-sizing:border-box;border:var(--bw,1px) solid transparent;pointer-events:none;z-index:2;overflow:visible;visibility:hidden;border-radius:calc(var(--bw,1px) * .18)}',
      '.pnl-cof.is-ready{visibility:visible}',
      /* กัน Dawn div:empty{display:none} */
      '.pnl-cof,.pnl-cof__mat,.pnl-cof__art,.pnl-cof__sheen,.pnl-cof__tex{display:block!important}',

      '.pnl-cof.f-black{border-color:#3a3a3a #141414 #050505 #2a2a2a;box-shadow:inset -1px -1px 2px rgba(0,0,0,.6),0 1px 3px rgba(0,0,0,.4)}',
      '.pnl-cof.f-white{border-color:#ffffff #e2e2e2 #dcdcdc #f4f4f4;box-shadow:inset -1px -1px 2px rgba(0,0,0,.18),0 1px 3px rgba(0,0,0,.28)}',
      '.pnl-cof.f-gold{border-color:#f6e6a8 #a87f33 #8a6420 #e6c878;box-shadow:inset -1px -1px 2px rgba(0,0,0,.45),0 1px 3px rgba(0,0,0,.35)}',
      '.pnl-cof.f-lightwood{border-image:url("' + WOOD.lightwood + '") 50 round;box-shadow:inset 0 0 0 1px rgba(0,0,0,.2),0 1px 3px rgba(0,0,0,.35)}',
      '.pnl-cof.f-darkwood{border-image:url("' + WOOD.darkwood + '") 50 round;box-shadow:inset 0 0 0 1px rgba(0,0,0,.3),0 1px 3px rgba(0,0,0,.4)}',

      '.pnl-cof__mat{position:absolute;inset:0;background:#fff;opacity:0;box-shadow:inset 1px 1px 2px rgba(0,0,0,.22)}',
      '.pnl-cof.has-mat .pnl-cof__mat{opacity:1}',
      '.pnl-cof.no-frame .pnl-cof__mat{inset:calc(-1.2 * var(--bw,1px))}',
      '.pnl-cof__art{position:absolute;left:0;top:0;width:0;height:0;background-repeat:no-repeat}',

      '.pnl-cof.is-canvas{border-color:transparent!important;border-image:none!important;box-shadow:none!important}',
      '.pnl-cof.is-canvas .pnl-cof__mat{opacity:1;inset:calc(-1 * var(--bw,1px));background:transparent;box-shadow:none}',

      '.pnl-cof__sheen{position:absolute;inset:0;opacity:0;background:linear-gradient(120deg,rgba(255,255,255,.28) 0%,rgba(255,255,255,.08) 30%,rgba(255,255,255,0) 50%)}',
      '.pnl-cof.is-paper:not(.is-canvas) .pnl-cof__sheen{opacity:1}',

      '.pnl-cof__tex{position:absolute;inset:0;opacity:0;background:linear-gradient(115deg,rgba(255,255,255,.02),rgba(0,0,0,.04))}',
      '.pnl-cof.is-canvas-tex .pnl-cof__tex{opacity:1}',
      '.pnl-cof.is-canvas .pnl-cof__tex{inset:calc(-1 * var(--bw,1px))}'
    ].join('\n');
    var s = document.createElement('style');
    s.id = 'pnl-cof-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ────────── helpers ────────── */
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  function mk(cls) { var d = document.createElement('div'); d.className = cls; return d; }
  function getImg(c) { return c.querySelector('img.cart-item__image') || c.querySelector('img'); }
  function dataSig(c) {
    var d = c.dataset;
    return DATA_KEYS.map(function (k) { return d[k] || ''; }).join('|');
  }
  function snap(v) {
    var dpr = window.devicePixelRatio || 1;
    return Math.round(v * dpr) / dpr;
  }
  function pct(v) {
    if (!v) return 0.5;
    if (/%$/.test(v)) return parseFloat(v) / 100;
    if (v === 'left' || v === 'top') return 0;
    if (v === 'right' || v === 'bottom') return 1;
    return 0.5;
  }

  /* กล่องเนื้อภาพจริง (รองรับ object-fit cover/contain) */
  function contentRect(img, x, y, w, h) {
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) return { x: x, y: y, w: w, h: h };
    var cs = getComputedStyle(img);
    var fit = cs.objectFit;
    if (fit !== 'cover' && fit !== 'contain' && fit !== 'scale-down') return { x: x, y: y, w: w, h: h };
    var s = fit === 'cover' ? Math.max(w / nw, h / nh) : Math.min(w / nw, h / nh);
    if (fit === 'scale-down') s = Math.min(1, s);
    var cw = nw * s, ch = nh * s;
    var pos = (cs.objectPosition || '50% 50%').split(/\s+/);
    return { x: x + (w - cw) * pct(pos[0]), y: y + (h - ch) * pct(pos[1] || pos[0]), w: cw, h: ch };
  }

  /* ────────── observers / scheduler ────────── */
  var tracked = new Set();
  var queue = new Set();
  var rafId = 0;

  var ro = window.ResizeObserver ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) {
      var c = e.target.closest ? e.target.closest(SEL) : null;
      if (c) schedule(c);
    });
  }) : null;

  function schedule(c) {
    queue.add(c);
    if (!rafId) rafId = requestAnimationFrame(flush);
  }

  function flush() {
    rafId = 0;
    var items = Array.from(queue);
    queue.clear();
    /* อ่านทั้งหมดก่อน แล้วค่อยเขียน → ไม่เกิด layout thrash */
    var jobs = [];
    items.forEach(function (c) { var j = measure(c); if (j) jobs.push(j); });
    jobs.forEach(apply);
  }

  function untrack(c) {
    tracked.delete(c);
    if (ro) {
      ro.unobserve(c);
      if (c._pnlImg) ro.unobserve(c._pnlImg);
    }
    c._pnlBox = null;
    c._pnlImg = null;
  }

  function sweep() {
    tracked.forEach(function (c) { if (!c.isConnected) untrack(c); });
  }

  /* ────────── build ────────── */
  function ensure(c) {
    var sig = dataSig(c);
    var img = getImg(c);
    if (!img) return;

    var ok = c._pnlSig === sig && c._pnlImg === img &&
             (c._pnlBox === null ? !c._pnlNeed : (c._pnlBox && c._pnlBox.parentNode === c));
    if (ok) { schedule(c); return; }

    build(c, img, sig);
  }

  function build(c, img, sig) {
    /* ลบกล่องเก่า/กล่องที่ติดมากับ clone */
    Array.prototype.slice.call(c.children).forEach(function (ch) {
      if (ch.classList && ch.classList.contains('pnl-cof')) ch.remove();
    });

    if (ro && c._pnlImg && c._pnlImg !== img) ro.unobserve(c._pnlImg);
    c._pnlSig = sig;
    c._pnlImg = img;
    c._pnlBox = null;
    c._pnlNeed = false;

    var d = c.dataset;
    var material = d.pnlMaterial || '';
    var canvasNoFrame = material === 'แคนวาสไม่มีกรอบ';
    var frame = (d.pnlFrame || '').replace('frame-color-', '');
    var wantMat = !canvasNoFrame && d.pnlBorder === 'เว้นขอบขาว' && d.pnlWb !== '1';

    if (!frame && !wantMat && !canvasNoFrame) return;
    c._pnlNeed = true;

    var box = mk('pnl-cof');
    var mat = mk('pnl-cof__mat');
    var art = mk('pnl-cof__art');
    mat.appendChild(art);
    box.appendChild(mat);
    box.appendChild(mk('pnl-cof__sheen'));
    box.appendChild(mk('pnl-cof__tex'));

    if (canvasNoFrame) box.classList.add('is-canvas');
    else if (frame) box.classList.add('f-' + frame);
    else box.classList.add('no-frame');
    if (wantMat) box.classList.add('has-mat');
    if (material === 'กระดาษ') box.classList.add('is-paper');
    if (material === 'แคนวาส' || canvasNoFrame) box.classList.add('is-canvas-tex');

    c.appendChild(box);
    c._pnlBox = box;
    box._art = art;
    box._sig = '';

    if (!img._pnlHook) {
      img._pnlHook = true;
      img.addEventListener('load', function () {
        var cc = img.closest(SEL);
        if (cc) schedule(cc);
      });
    }

    tracked.add(c);
    if (ro) { ro.observe(c); ro.observe(img); }
    schedule(c);
  }

  /* ────────── measure (read only) ────────── */
  function measure(c) {
    if (!c.isConnected) { untrack(c); return null; }
    var box = c._pnlBox, img = c._pnlImg;
    if (!box || !img || !img.isConnected) return null;

    var cw = c.offsetWidth;
    if (!cw) return null;
    var cb = c.getBoundingClientRect();
    var scale = cb.width / cw || 1;            /* หักล้าง transform/animation ของธีม */
    var ib = img.getBoundingClientRect();
    var ew = ib.width / scale, eh = ib.height / scale;
    if (!ew || !eh) return null;
    var ex = (ib.left - cb.left) / scale - c.clientLeft;
    var ey = (ib.top  - cb.top)  / scale - c.clientTop;

    var r = contentRect(img, ex, ey, ew, eh);

    var d = c.dataset;
    var mode = d.pnlMode === 'portrait' ? 'portrait' : 'landscape';
    var W = num(d.pnlW, DEF[mode].w);
    var H = num(d.pnlH, DEF[mode].h);
    var X = num(d.pnlX, 0);
    var Y = num(d.pnlY, 0);
    var T = num(d.pnlT, BASE_T);

    var w = r.w * W / 100;
    var h = r.h * H / 100;
    var left = r.x + (r.w - w) / 2 + w * X / 100;
    var top  = r.y + (r.h - h) / 2 + h * Y / 100;
    var bw = Math.max(1, T * (r.w / REF_W));

    return {
      box: box,
      src: img.currentSrc || img.src || '',
      r: r,
      bw: snap(bw),
      left: snap(left), top: snap(top), w: snap(w), h: snap(h)
    };
  }

  /* ────────── apply (write only) ────────── */
  function apply(j) {
    var box = j.box;
    var sig = [j.left, j.top, j.w, j.h, j.bw, j.r.x, j.r.y, j.r.w, j.r.h, j.src].join(',');
    if (box._sig === sig) return;
    box._sig = sig;

    box.style.transform = 'translate(' + j.left + 'px,' + j.top + 'px)';
    box.style.width  = j.w + 'px';
    box.style.height = j.h + 'px';
    box.style.setProperty('--bw', j.bw + 'px');

    applyArt(j);
    box.classList.add('is-ready');
  }

  function applyArt(j) {
    var box = j.box, art = box._art;
    var isCanvas = box.classList.contains('is-canvas');
    var hasMat = box.classList.contains('has-mat');
    if (!art || (!isCanvas && !hasMat) || !j.src) return;

    var bw = j.bw, w = j.w, h = j.h, r = j.r;
    var pad = bw * 2;                       /* ขอบกรอบ + ตัดกรอบดำที่ติดมาในรูป */
    var irW = w - pad * 2;
    var irH = h - pad * 2;
    if (irW <= 0 || irH <= 0) return;

    var ax, ay, aw, ah;
    if (isCanvas) {
      ax = 0; ay = 0; aw = w; ah = h;
    } else {
      var m = irW * MAT_RATIO;
      ax = pad + m; ay = pad + m;
      aw = irW - 2 * m; ah = irH - 2 * m;
    }

    /* จุดเริ่มของ .pnl-cof__mat ในพิกัด border-box ของกล่อง */
    var matOrigin = isCanvas ? 0 : (box.classList.contains('no-frame') ? -0.2 * bw : bw);

    var sx = aw / irW, sy = ah / irH;
    var boxInImgX = j.left - r.x;
    var boxInImgY = j.top  - r.y;

    art.style.left   = (ax - matOrigin) + 'px';
    art.style.top    = (ay - matOrigin) + 'px';
    art.style.width  = aw + 'px';
    art.style.height = ah + 'px';
    art.style.backgroundImage = 'url("' + j.src.replace(/"/g, '%22') + '")';
    art.style.backgroundSize = (r.w * sx) + 'px ' + (r.h * sy) + 'px';
    art.style.backgroundPosition =
      (-(boxInImgX + pad) * sx) + 'px ' + (-(boxInImgY + pad) * sy) + 'px';
  }

  /* ────────── scan ────────── */
  function scan() {
    sweep();
    document.querySelectorAll(SEL).forEach(ensure);
  }
  function layoutAll() {
    tracked.forEach(function (c) { if (c._pnlBox) { c._pnlBox._sig = ''; schedule(c); } });
  }

  var scanTimer = null;
  function scanSoon() { clearTimeout(scanTimer); scanTimer = setTimeout(scan, 40); }

  function relevant(n) {
    if (!n || n.nodeType !== 1) return false;
    if (n.classList && (n.classList.contains('pnl-cof') || (n.closest && n.closest('.pnl-cof')))) return false;
    if (n.matches(SEL) || n.querySelector(SEL)) return true;
    return n.tagName === 'IMG' && !!n.closest(SEL);
  }

  /* boot */
  injectCSS();

  /* ล้างกล่องจาก v1 ที่อาจค้างอยู่ */
  document.querySelectorAll(SEL + ' > .pnl-cof').forEach(function (b) { b.remove(); });

  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        var k;
        for (k = 0; k < m.addedNodes.length; k++) if (relevant(m.addedNodes[k])) { scanSoon(); return; }
        for (k = 0; k < m.removedNodes.length; k++) if (relevant(m.removedNodes[k])) { scanSoon(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('pnl:cart-updated', scanSoon);
  document.addEventListener('shopify:section:load', scanSoon);
  window.addEventListener('pageshow', function () { scanSoon(); layoutAll(); });
  window.addEventListener('load', layoutAll);
  window.addEventListener('resize', layoutAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(layoutAll);

  window.PnlCartFrame = { v: VERSION, scan: scan, layout: layoutAll };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();